// Reactインポート
import React from "react";

// ゲットナビゲータ
import Header from "../components/Header";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

// スタイルインポート
import "../pages/css/service.scss";
import "../responsive/ServicesResponsive.scss";
import "../common.scss";

// メインビジュアル
import headerSubImg from "../img/services/services.jpg";

// 縦線
import line from "../img/services/Rectangle.svg";

// サービス一覧
import serviceImg1 from "../img/services/homepage.jpg";
import serviceImg1sp from "../img/services/sp/homepage-sp.jpg";

import serviceImg2 from "../img/services/homepage.jpg";
import serviceImg2sp from "../img/services/sp/web-support.jpg";

import serviceImg3 from "../img/services/service-design-pic.png";
import serviceImg3sp from "../img/services/sp/service-design-sp.jpg";

import serviceImg4 from "../img/services/online-shop.jpg";
import serviceImg4sp from "../img/services/sp/online-shop-sp.jpg";

// worksImg
import serviceWorkImg from "../img/services/service-works.png";

function Services() {
  return (
    <>
      <Header />
      <main id="services">
        <article className="sub-image">
          <div className="sub-main-image position-about">
            <img
              src={headerSubImg}
              alt="アイテム　｜ ヘッダーイメージ"
            ></img>
          </div>
        </article>
        <section className="srv-sec">
          <div className="sub-sec-company-ttl">
            <div className="borderA"></div>
            <h2 data-desc="サービス">SERVICES</h2>
            <div className="borderB"></div>
          </div>
          <div className="srv-sec-mission">
            いつの時代もWEBサイトは作り手のものではなく、ご依頼いただくお客様のものです。
            <br className="pcOnly" />
            デザインやWEB制作、ITの専門家として、お客様に今必要なカタチを企画・製作いたします。
          </div>
        </section>
        <section className="srv01-sec01">
          <div className="srv-title">
            <img src={line} alt="縦線" />
            <h3 className="srv-ttl-main" data-num="01">
              SERVICE
            </h3>
            <div className="num">01</div>
          </div>
          <div className="srv-desc">
            <div className="srv-desc-img mr30 pcOnly">
              <img src={serviceImg1} alt="" />
            </div>
            <div className="srv-desc-img spOnly">
              <img src={serviceImg1sp} alt="" />
            </div>
            <div className="srv-desc-ex">
              <div className="ttl">
                WEBサイト制作・
                <span class="blue">ホームページ制作</span>
              </div>
              <div className="desc">
                スマートフォン、タブレットなどの各端末に対応した、見やすい・分かりやすい・使いやすい機能美と、デザイナーの知識・経験から生み出されるビジュアル美の双方を兼ね備えたWEBサイトをご提供いたします。企画からデザインまで一から携わり、ご要望に沿う丁寧なヒアリングを重ねてブラッシュアップ。トレンドを意識し、ユーザーに強く印象づけます。
              </div>
              <div className="srv-desc-checklist">
                <ul>
                  <li>
                    ビジネス上で
                    <br />
                    信頼感が得られる
                  </li>
                  <li>
                    ネット経由で集客を
                    <br />
                    することができる
                  </li>
                  <li>
                    情報発信による企業の
                    <br />
                    信頼や安心感の向上！
                  </li>
                  <li>
                    営業ツール
                    <br />
                    として利用できる！
                  </li>
                  <li>
                    求人募集のツールの
                    <br />
                    ひとつとして活用できる
                  </li>
                  <li>
                    マーケティングに
                    <br />
                    活用できる
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="srv02-sec02">
          <div className="srv-title">
            <img src={line} alt="縦線" />
            <h3 className="srv-ttl-main" data-num="02">
              SERVICE
            </h3>
            <div className="num">02</div>
          </div>
          <div className="srv-desc row-reverse">
            <div className="srv-desc-img pcOnly">
              <img src={serviceImg2} alt="" />
            </div>
            <div className="srv-desc-img spOnly">
              <img src={serviceImg2sp} alt="" />
            </div>
            <div className="srv-desc-ex">
              <div className="ttl">
                WEB<span className="blue pl0">開発支援</span>
              </div>
              <div className="desc">
                ショッピングサイトや不動産管理システム、求人サイトなどのオンランサービスを開発し、インターネットデバイスを使用して幅広い顧客を獲得できます。
              </div>
              <div className="srv-desc-checklist">
                <ul>
                  <li>
                    ビジネス上で
                    <br />
                    信頼感が得られる
                  </li>
                  <li>
                    ネット経由で集客を
                    <br />
                    することができる
                  </li>
                  <li>
                    情報発信による企業の
                    <br />
                    信頼や安心感の向上！
                  </li>
                  <li>
                    営業ツール
                    <br />
                    として利用できる！
                  </li>
                  <li>
                    求人募集のツールの
                    <br />
                    ひとつとして活用できる
                  </li>
                  <li>
                    アクセス解析等によって
                    <br />
                    マーケティングに活用できる
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="srv03-sec03">
          <div className="srv-title">
            <img src={line} alt="縦線" />
            <h3 className="srv-ttl-main" data-num="03">
              SERVICE
            </h3>
            <div className="num">03</div>
          </div>
          <div className="srv-desc row-reverse">
            <div className="srv-desc-img pcOnly">
              <img src={serviceImg3} alt="" />
            </div>
            <div className="srv-desc-img spOnly">
              <img src={serviceImg3sp} alt="" />
            </div>
            <div className="srv-desc-ex">
              <div className="ttl">
                <span className="blue pl0">グラフィック</span>
                デザイン制作
              </div>
              <div className="desc">
                名刺やチラシ、パンフレットなどの小さなサイズから対応します。まずはお客様のご要望を用件定義し、膨大な選択肢からふさわしい紙質を見極め、グラフィックの形状までをご提案します。写真、イラスト、文字組みといった要素を用いてアイデアを出し合い、お客さまが発信したい情報とイメージを実現させます。
              </div>
              <ul className="annotation-list">
                <li>
                  名刺作成や簡単なチラシの制作も受け付けておりますので、
                  <a className="blue pl0" href="/">
                    お気楽に問合せください
                  </a>
                </li>
                <li>制作期間の目安は1ヶ月〜2ヶ月となります。</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="srv04-sec04">
          <div className="srv-title">
            <img src={line} alt="縦線" />
            <h3 className="srv-ttl-main" data-num="04">
              SERVICE
            </h3>
            <div className="num">04</div>
          </div>
          <div className="srv-desc">
            <div className="srv-desc-img mr30 pcOnly">
              <img src={serviceImg4} alt="" />
            </div>
            <div className="srv-desc-img spOnly">
              <img src={serviceImg4sp} alt="" />
            </div>
            <div className="srv-desc-ex">
              <div className="ttl">
                ECウェブアプリケーションの
                <span className="blue pl0">運営代行</span>
              </div>
              <div className="desc">
                ECの運営に必要なサイト制作、広告運用、在庫管理、高品質画像の差し替え等の業務には幅広いスキルや知識が求められます。これらを全て自社で補うことは大変な手間やコストがかかります。そのため、お客様に代行してECの運営に関する業務を全般または部分的に代行するサービスを提供いたします。
              </div>
              <ul className="annotation-list">
                <li>画像やサイトがある場合は事前にご共有ください。</li>
                <li>制作依頼の場合の開発期間は2ヶ月〜4ヶ月となります。</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="section-works">
          <div className="works-desc">
            <div className="works-ttl">WORKS</div>
            <div className="works-txt">
              WEBではお客様との制作に関する契約上、一部の実績のみ公開しております。
              <br />
              その他の制作実績もご用意しておりますので、
              <a href="/">お気楽に問合せください</a>
            </div>
            <div className="btn-rigth typo-en">
              <div className="btn-line"></div>
              <div className="btn-txt">MORE</div>
            </div>
          </div>
          <div className="works-img">
            <img src={serviceWorkImg} alt="" />
          </div>
        </section>
        <Contact />
        <Footer />
      </main>
    </>
  );
}

export default Services;
